import React from "react"



const StepThree = () => {
    return(
        <div className="step-3 steps">
               <div className="display-lap2">
                <h1>"Instant" Cash</h1>
                <p>Your funds are disbursed electronically into your salary account same day.</p>
            </div>
        </div>
    )
}

export default StepThree